import "./ResetPasswordPage.less";

import { message, notification, Button, Icon, Spin } from "antd";
import * as React from "react";
import { withRouter, Link, RouteComponentProps } from "react-router-dom";

import { CancellationToken } from "lib/api/base";
import { PasswordApi } from "lib/api/security/passwordReset";
import { IBaseProps } from "lib/data/interfaces";
import { StateService } from "lib/services";

import { TransitionRoute } from "components/general/TransitionRoute";
import { SetPassword } from "./components/SetPassword";


interface IResetPasswordPageProps extends IBaseProps, RouteComponentProps<any> {
	match: any;
}

interface IResetPasswordPageState {
	newPassword: string;
	confirmPassword: string;
	componentInView: "reset-password" | "loading" | "invalid-token";
}

export class ResetPasswordPagePreRouter extends React.Component<IResetPasswordPageProps, IResetPasswordPageState> {

	public static readonly BasePath: string = "/reset-password";


	private apiCancellationToken: CancellationToken = new CancellationToken();

	public constructor(props: IResetPasswordPageProps) {

		super(props);

		this.state = {
			newPassword: "",
			confirmPassword: "",
			componentInView: "loading"
		};
	}

	public componentWillMount = () => {

		this.checkTokenIsValid();
	}

	public componentWillUnmount() {

		// Cancel Outstanding API Calls
		this.apiCancellationToken.cancel();
	}

	public render() {

		return (

			<div className="password-reset-page">
				<TransitionRoute on={this.state.componentInView} case={"loading"}>
					<Spin />
				</TransitionRoute>
				<TransitionRoute on={this.state.componentInView} case={"reset-password"}>
					<SetPassword newPassword={this.state.newPassword} confirmPassword={this.state.confirmPassword} inputHandler={this.inputHandler} resetPassword={this.resetPassword} />
				</TransitionRoute>
				<TransitionRoute on={this.state.componentInView} case={"invalid-token"}>
					<div>
						<p className="invalid-token">
							<Icon type="close" /> Your reset has expired, please select the forgot password link again on login to get a new link.
					</p>
						<Link to="/login">
							<Button type="primary">
								Go To Login
							</Button>
						</Link>
					</div>
				</TransitionRoute>
			</div >
		);
	}

	private hasWhiteSpace = (s: any) => {

		return s.indexOf(" ") >= 0;
	}

	private inputHandler = (e: any) => {

		const { name, value } = e.target;

		if (this.hasWhiteSpace(value)) {

			message.warn("Passwords cannot contain spaces. Please try again");
		}
		else {

			StateService.setCancelableState(() => this.setState({ [name]: value }), this.apiCancellationToken);
		}
	}

	private checkTokenIsValid = async () => {

		const { token } = this.props.match.params;

		const valid = await PasswordApi.getPasswordResetToken(token);

		if (valid !== undefined) {

			StateService.setCancelableState(() => this.setState({ componentInView: "reset-password" }), this.apiCancellationToken);
		}
		else {

			message.error(`The url you used was invalid, please obtain a new one by using the forgot email feature.`, 10);

			this.props.history.push("/login");
		}
	}

	private resetPassword = async () => {

		const { token } = this.props.match.params;

		const { newPassword } = this.state;

		const passwordWasReset = await PasswordApi.resetPassword(newPassword, token);

		if (passwordWasReset != null) {

			notification.success({
				message: "Success",
				description: "Password Reset Complete. Please Login.",
				duration: 8
			});

			this.props.history.push("/login");
		}
		else {

			notification.error({
				message: "Error",
				description: "Password Reset Failed. Please Contact Your System Administrator.",
				duration: 8
			});

			this.props.history.push("/login");
		}
	}
}


export const ResetPasswordPage = withRouter(ResetPasswordPagePreRouter);
